import { ThemeOptions } from '@mui/material';

import * as MuiBreadcrumbs from './MuiBreadcrumbs';
import * as MuiLink from './MuiLink';
import * as MuiTabs from './MuiTabs';

export type {} from './MuiBreadcrumbs';
export type {} from './MuiLink';
export type {} from './MuiTabs';

export const navigation: ThemeOptions['components'] = {
  ...MuiBreadcrumbs,
  ...MuiLink,
  ...MuiTabs
};
